import { useEffect, useRef, useState } from "react";

// Muestra los botones flotantes mientras hay scroll (arriba o abajo) y los
// oculta tras 30 s de inactividad. Cualquier scroll reinicia el contador.
// `keepVisible` (panel abierto) mantiene el botón visible sin importar el scroll.
const IDLE_MS = 30000;

export function useScrollFloatVisibility(keepVisible = false) {
  const [scrollVisible, setScrollVisible] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      setScrollVisible(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setScrollVisible(false), IDLE_MS);
    };
    // capture:true captura el scroll de contenedores anidados (menú móvil,
    // paneles, modales) que no burbujean al window — vital en Android WebView.
    window.addEventListener("scroll", onScroll, { passive: true, capture: true });
    window.addEventListener("touchmove", onScroll, { passive: true, capture: true });
    return () => {
      window.removeEventListener("scroll", onScroll, { capture: true });
      window.removeEventListener("touchmove", onScroll, { capture: true });
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return keepVisible || scrollVisible;
}